import React from 'react';
import { List, useTable, EditButton, ShowButton, DeleteButton } from '@refinedev/antd';
import { Table, Space, Tag } from 'antd';
import { IResourceComponentsProps, BaseRecord } from '@refinedev/core';

export const SubscriptionList: React.FC<IResourceComponentsProps> = () => {
  const { tableProps } = useTable({
    resource: 'products/subscription-plans',
    syncWithLocation: true,
  });

  return (
    <List title="Subscription Plans">
      <Table {...tableProps} rowKey="id">
        <Table.Column dataIndex="name" title="Name" />
        <Table.Column
          dataIndex="isActive"
          title="Status"
          render={(value) => (
            <Tag color={value ? 'green' : 'red'}>{value ? 'Active' : 'Inactive'}</Tag>
          )}
        />
        <Table.Column dataIndex="price" title="Price" />
        <Table.Column dataIndex="durationDays" title="Duration (Days)" />
        <Table.Column
          title="Actions"
          dataIndex="actions"
          render={(_, record: BaseRecord) => (
            <Space>
              <EditButton
                hideText
                size="small"
                recordItemId={record.id}
                resource="products/subscription-plans"
              />
              <ShowButton
                hideText
                size="small"
                recordItemId={record.id}
                resource="products/subscription-plans"
              />
              <DeleteButton
                hideText
                size="small"
                recordItemId={record.id}
                resource="products/subscription-plans"
              />
            </Space>
          )}
        />
      </Table>
    </List>
  );
};
